module.exports = ".front-page-hero {\n  background-color: #24628E;\n  color: #fff; }\n\n.face {\n  background-image: url(\"/assets/images/face.png\");\n  background-repeat: no-repeat;\n  height: 400px; }\n\nbody, html {\n  height: 100%; }\n\n.bg {\n  /* The image used */\n  background-image: url(\"/assets/images/1.jpg\");\n  /* Full height */\n  height: 400px;\n  /* Center and scale the image nicely */\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  z-index: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/perche-sceglierci/perche-sceglierci.component.scss
// module id = ./src/app/perche-sceglierci/perche-sceglierci.component.scss
// module chunks = main